import { call, put } from 'redux-saga/effects';
import { finishLoading, startLoading } from '../modules/loading';

export const createRequestActionTypes = (type) => {
  const SUCCESS = `${type}_SUCCESS`;
  const FAILULE = `${type}_FAILULE`;

  return [type, SUCCESS, FAILULE];
};

export default function createRequestSaga(type, request) {
  const SUCCESS = `${type}_SUCCESS`;
  const FAILULE = `${type}_FAILULE`;

  /**
   * 제너레이터 함수 : 이 문법의 핵심 기능은 함수를 작성할 때 함수를 특정 구간에 멈춰 놓을 수도 있고,
   * 원할 때 다시 돌아가게 할 수도 있다는 것이다.
   */
  return function* (action) {
    yield put(startLoading(type)); //로딩 시작

    try {
      const response = yield call(request, action.payload);


      yield put({
        type: SUCCESS,
        payload: response.data,
      });
    } catch (e) {
      yield put({
        type: FAILULE,
        payload: e,
        error: true,
      });
    }
    yield put(finishLoading(type)); //로딩 끝
  };
}
